import React, { useRef, useState, useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import emailjs from '@emailjs/browser';
import './ContactMe.css';
import contactillustration from './Emailcampaign-amico.png';
import Facebook from './../../Assets/facebook.png';
import Instagram from './../../Assets/instagram.png';
import Twitter from './../../Assets/twitter.png';


const ContactMe = () => {


  useEffect(() => {
    AOS.init();
  }, [])

  const form = useRef();
  const [emptyFields, setEmptyFields] = useState([]);

  const sendEmail = (e) => {
    e.preventDefault();

    const toName = form.current.to_name.value.trim();
    const userEmail = form.current.user_email.value.trim();
    const message = form.current.message.value.trim();

    const validateEmail = (email) => {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(email);
    };

    const emptyFieldsArray = [];
    if (!toName) {
      emptyFieldsArray.push('to_name');
    }
    if (!userEmail || !validateEmail(userEmail)) {
      emptyFieldsArray.push('user_email');
    }
    if (!message) {
      emptyFieldsArray.push('message');
    }

    setEmptyFields(emptyFieldsArray);

    if (emptyFieldsArray.length > 0) {
      alert('Please fill in all fields.');
      return;
    } else {
      emailjs
        .sendForm('service_j1jptta', 'template_0hlwnqg', form.current, '7hyWYwJIT-wYhGHy0')
        .then(
          (result) => {
            console.log(result.text);
            e.target.reset();
            alert('Email Sent!');
          },
          (error) => {
            console.log(error.text);
          }
        );
    }
  };

  
  return (
    <section id="contact">
          <div className="contactContainer">
              <div className="contactIntro">
                  <h1 
                data-aos="fade-up"
                data-aos-offset="-400"
                data-aos-delay="50"
                data-aos-duration="1000"
                data-aos-easing="ease"
                data-aos-mirror="true"
                data-aos-once="false"
                data-aos-anchor-placement="top-center">Contact Me</h1>
                  <p 
                data-aos="fade-up"
                data-aos-offset="-400"
                data-aos-delay="50"
                data-aos-duration="1000"
                data-aos-easing="ease"
                data-aos-mirror="true"
                data-aos-once="false"
                data-aos-anchor-placement="top-center">Please fill out the form below to initiate discussing about potential job opportunities.</p>
              </div>
              <div className="contactDesign">
                   <div className="illustrationContact" 
                                  data-aos="fade-right"
                                  data-aos-offset="-400"
                                  data-aos-delay="50"
                                  data-aos-duration="1000"
                                  data-aos-easing="ease"
                                  data-aos-mirror="true"
                                  data-aos-once="false"
                                  data-aos-anchor-placement="top-center">
                        <img src={contactillustration} alt="ContactMe" className='illustrationIMG' />
                   </div>                                    
                    <div className="contactFillForm">
                        <div className="emailForm">
                           <form className="contactForm" ref={form} onSubmit={sendEmail}>
                              <input 
                                  data-aos="fade-left"
                                  data-aos-offset="-400"
                                  data-aos-delay="100"
                                  data-aos-duration="1000"
                                  data-aos-easing="ease"
                                  data-aos-mirror="true"
                                  data-aos-once="false"
                                  data-aos-anchor-placement="top-center" type="text" className={`name ${emptyFields.includes('to_name') ? 'emptyField' : ''}`} placeholder='Your Name' name="to_name" />
                               <input 
                                  data-aos="fade-left"
                                  data-aos-offset="-400"
                                  data-aos-delay="200"
                                  data-aos-duration="1000"
                                  data-aos-easing="ease"
                                  data-aos-mirror="true"
                                  data-aos-once="false"
                                  data-aos-anchor-placement="top-center" type="email" className={`email ${emptyFields.includes('user_email') ? 'emptyField' : ''}`} placeholder='Your Email' name="user_email" />
                               <textarea 
                                  data-aos="fade-left"
                                  data-aos-offset="-400"
                                  data-aos-delay="300"
                                  data-aos-duration="1000"
                                  data-aos-easing="ease"
                                  data-aos-mirror="true"
                                  data-aos-once="false"
                                  data-aos-anchor-placement="top-center" name="message" rows="5" className={`msg ${emptyFields.includes('message') ? 'emptyField' : ''}`} placeholder='Your Message'></textarea>
                               <button 
                                  data-aos="fade-left"
                                  data-aos-offset="-400"
                                  data-aos-delay="50"
                                  data-aos-duration="1000"
                                  data-aos-easing="ease"
                                  data-aos-mirror="true"
                                  data-aos-once="false"
                                  data-aos-anchor-placement="top-center" className="submitBtn" type='submit' value='Send'>Submit</button>
                           </form>
                            <small 
                                  data-aos="fade"
                                  data-aos-offset="-400"
                                  data-aos-delay="50"
                                  data-aos-duration="1000"
                                  data-aos-easing="ease"
                                  data-aos-mirror="true"
                                  data-aos-once="false"
                                  data-aos-anchor-placement="top-center">Or message me through social media accounts</small>
                            <div className="links" 
                                  data-aos="fade-up"
                                  data-aos-offset="-400"
                                  data-aos-delay="50"
                                  data-aos-duration="1000"
                                  data-aos-easing="ease"
                                  data-aos-mirror="true"
                                  data-aos-once="false"
                                  data-aos-anchor-placement="top-center">
                                 <a href="https://www.facebook.com/sherwenlovesherwen/" target="_blank" rel="noopener noreferrer">
                                 <img src={Facebook} alt="Facebook" className='SocialAccounts' />
                                 </a>
                                 <a href="https://www.instagram.com/sharewenn/" target="_blank" rel="noopener noreferrer">
                                 <img src={Instagram} alt="Instagram" className='SocialAccounts' />
                                 </a>
                                 <a href="https://x.com/seeewin?t=maKhXhVfOkNoAVBsCBWwPQ&s=09" target="_blank" rel="noopener noreferrer">
                                 <img src={Twitter} alt="Twitter" className='SocialAccounts' />
                                 </a>
                            </div>

                        </div>
                  </div>
              </div>
            <div className="footer">

            </div>
             
          </div>
    </section>
  )
}

export default ContactMe
